module.exports = __webpack_public_path__ + "static/img3-f2a26636282766e90a797726dfdcf103.png";